import dayjs from "dayjs";
import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { AllderTable } from "../../components/AllderTable";
import { useGlobalTable } from "../../hooks/useGlobalTable";
import { customerHandler } from "../../redux/handlers";
import { createTableColumns } from "../../utils/createTableColumns";

export function CustomerManagement() {
  const dispatch = useDispatch();

  const fetchCustomerData = useCallback(
    (params) => dispatch(customerHandler.getCustomers(params)),
    [dispatch]
  );

  const {
    data: customerData,
    loading,
    totalRows,
    paginationModel,
    setPaginationModel,
    handleSort,
    debouncedSearch,
    filterParams,
  } = useGlobalTable({
    fetchData: fetchCustomerData,
    defaultSort: "created_at",
    defaultOrder: "desc",
    defaultPageSize: 20,
  });

  const handleExport = () => {
    dispatch(customerHandler.exportCustomerToExcel(filterParams?.s));
  };

  const columns = createTableColumns([
    {
      field: "code",
      headerName: "รหัสลูกค้า",
      width: 140,
      sortable: true,
      renderCell: ({ row }) => (
        <Link
          to={`/customer/manage/${row.id}`}
          className="text-[#2DC76D] underline"
        >
          {row.code}
        </Link>
      ),
    },
    {
      field: "fullName",
      headerName: "ชื่อลูกค้า",
      width: 280,
      flex: 1,
      minWidth: 280,
      sortable: false,
      renderCell: ({ row }) => (
        <div>
          {`${row.prefixName?.name || ""} ${row.first_name || ""} ${
            row.last_name || ""
          }`}
        </div>
      ),
    },
    {
      field: "created_at",
      headerName: "วันที่ลงทะเบียน",
      width: 180,
      sortable: true,
      renderCell: ({ row }) => (
        <div>{dayjs(row.created_at).format("DD/MM/YYYY")}</div>
      ),
    },
    {
      field: "phone_number",
      headerName: "เบอร์โทร",
      width: 180,
      sortable: false,
    },
    {
      field: "email",
      headerName: "E-MAIL",
      width: 240,
      sortable: false,
    },
    {
      field: "businessCount",
      headerName: "จำนวนธุรกิจ",
      width: 150,
      sortable: false,
      renderCell: ({ row }) => (
        <div>{row.businessGroup?.business?.length ?? 0}</div>
      ),
    },
    {
      field: "customerGroup",
      headerName: "กลุ่มลูกค้า",
      width: 150,
      sortable: false,
      renderCell: ({ row }) => (
        <div>{row.userBusinessCustomerGroup?.name || "-"}</div>
      ),
    },
    {
      field: "actions",
      headerName: "จัดการ",
      width: 100,
      sortable: false,
      renderCell: ({ row }) => (
        <div>
          <Link
            to={`/customer/manage/${row.id}`}
            type="button"
            className="btn-edit-st-1"
          />
        </div>
      ),
    },
  ]);

  return (
    <div>
      <nav aria-label="breadcrumb" className="mt-2">
        <ol className="breadcrumb fs-16 ps-0">
          <li className="breadcrumb-item">
            <Link to="/customers" className="tc-7 text-decoration-none">
              ลูกค้า
            </Link>
          </li>
          <li className="breadcrumb-item active tc-1" aria-current="page">
            รายชื่อลูกค้า
          </li>
        </ol>
      </nav>

      <div className="card card-st-2">
        <div className="card-body px-0 py-4">
          <div className="text-xl tc-7 px-4 mb-4 lh-1">รายชื่อลูกค้า</div>
          <div className="d-flex align-items-center px-4 mb-4">
            <button
              className="btn btn-export-st-1 me-auto"
              onClick={handleExport}
            >
              Export
            </button>
            <div className="me-3">
              <input
                type="text"
                className="form-control form-st-4"
                placeholder="ค้นหาชื่อลูกค้า"
                onChange={(e) => debouncedSearch(e.target.value)}
              />
            </div>
            {/* <Link to="/customer/manage" type="button" className="btn btn-st-7">
              เพิ่มลูกค้า
            </Link> */}
          </div>
          <AllderTable
            data={customerData}
            loading={loading}
            columns={columns}
            totalRows={totalRows}
            paginationModel={paginationModel}
            setPaginationModel={setPaginationModel}
            handleSort={handleSort}
          />
        </div>
      </div>
    </div>
  );
}
